// directive controller function
var ServiceItemController = function ($scope, $element, $attrs, $state, ssWidgetService, $timeout, apiConstants, customerModelService) {

    //if current service is an package - mark all children items as selected
    if (window.appSettings.enablePackages && ($scope.service.children instanceof Array) && ($scope.service.children.length > 0)) {
        $scope.isPackage = true;
        $scope.service.children.forEach(function (el) {
            el.selected = true;
        });
    }

    $scope.showLineComment = $scope.showLineComment || false;

    $scope.$watch('service.selected', function (newVal) {
        $scope.isPackageOpen = $scope.isPackage && newVal;
    });

    // flag that defines show price or not
    $scope.displayPrice = ($scope.displayPrice === undefined) ? true : $scope.displayPrice;

    // hasComment
    //
    // @return {boolean} true if service has comment otherwice false
    //
    // @description
    // Function checks if current service has a comment or not
    $scope.hasComment = function () {
        return !!($scope.service ? $scope.service.comment : undefined);
    };

    // isAdded
    //
    // @return {boolean} true if customer has added current service
    //
    // @description
    // Function checks if customer selected current service
    $scope.isAdded = function () {
        return !!$scope.service.selected;
    };

    // flag that defines if comment is shown. In case if service
    $scope.commentIsShown = $scope.hasComment() && $scope.isAdded();
    // selectService
    //
    // @description
    // Method makes select or deselect current service 
    $scope.selectService = function () {

        $scope.service.selected = !(!!$scope.service.selected);

        if ($scope.isPackage) {
            $scope.service.children.forEach(function (el) {
                el.selected = $scope.service.selected;
            });
        }

        if (!$scope.service.selected) {
            $scope.removeComment();
            $scope.removeSurvey();
            $scope.showSurveyDropdown = false;
        } else {
            if ($scope.onAddService) {
                $scope.onAddService.call(null, $scope.isPackage, $scope.service);
            }
            $scope.isPackageOpen = true;
        }

        $scope.$emit('ServiceItemController:serviceChanged');
    };

    // removeComment
    //
    // @description
    // Method removes comment and close comment popup
    $scope.removeComment = function () {
        $scope.service.comment = null;
        $scope.commentIsShown = false;

        $scope.$emit('ServiceItemController:serviceChanged');
    };
    // showCommentForm
    //
    // @description
    // Method shows/hides form for add/show coment according to
    // conditions
    $scope.showComment = function () {
        $scope.commentIsShown = !$scope.commentIsShown;
    };

    // showInfo
    //
    //@param {object} service object
    //
    //@description
    //Show the amenities related to the current service
    $scope.showInfo = function (service) {
        service.showAmenity = !!!service.showAmenity;
    };

    // removePackagedService
    //
    // @param {object} service object
    //
    // @description
    // Marks given service as going to be removed. Triggers confirmation
    // popup for user.
    $scope.removePackagedService = function (service) {
        service.$$aboutToRemove = true;
    };

    // cancelRemovingPackagedService
    //
    // @param {object} service object
    //
    // @description
    // Deletes marker of removing from given service and closes confirmation
    // popup
    $scope.cancelRemovingPackagedService = function (service) {
        if (service.$$aboutToRemove) {
            delete service.$$aboutToRemove;
        }
    };

    // confirmRemovingPackagedService
    //
    // @param {object} service object
    //
    // @description
    // Confirms removing the services. As the result calling callback passed
    // as a parameter of the current directive
    $scope.confirmRemovingPackagedService = function (service) {
        service.$$aboutToRemove && delete service.$$aboutToRemove;
        $scope.isPackageOpen = false;
        $scope.service.selected = false;
        $scope.service.children.forEach(function (el) {
            el.selected = false;
        });
        if ($scope.onBreakPackage instanceof Function) {
            $scope.onBreakPackage.call(null, $scope.service, service);
        }
    };

    // canBreakPackage
    //
    // @description
    // Checks if it is allowed to break package. Decision is based on two application
    // settings
    // allowUserToBreakPackages - breaking package is allowed or not
    // allowDeclineFrsPreselected - can or not decline preselected services
    $scope.canBreakPackage = function () {
        return window.appSettings.allowUserToBreakPackages && window.appSettings.allowDeclineFrsPreselected;
    };

    //is package list shown
    $scope.isPackageOpen = true;

    //Open\close package list
    $scope.switchPackageOpen = function () {
        if ($scope.isPackage) {
            $scope.isPackageOpen = !$scope.isPackageOpen;
        }
    };

    $scope.removeSSConfirmationShown = false;
    $scope.ssEnabled = ssWidgetService.isEnabled();
    $scope.availableSurveyTemplates = ssWidgetService.getAvailableSurveyTemplates();
    $scope.selectedSurveyTemplate = $scope.service.survey ?
        $scope.availableSurveyTemplates.filter(function (o) { return o.id === $scope.service.survey.templateId })[0] : null;
    $scope.showSurveyDropdown = !!$scope.selectedSurveyTemplate;

    $scope.selectSurveyTemplateHandler = function (surveyTemplate) {
        $state.go('bookappointment.survey', {
            serviceId: $scope.service.id,
            templateId: surveyTemplate.id,
            name: $scope.service.name
        });
    };

    $scope.editSurvey = function () {
        var survey = $scope.service.survey;
        if (!survey) return;
        $state.go('summary.survey', {
            serviceId: survey.serviceId,
            templateId: survey.templateId,
            name: survey.templateName,
        });
    };

    $scope.showRemoveSSConfirmation = function () {
        $scope.removeSSConfirmationShown = true;
    };

    $scope.hideRemoveSSConfirmation = function () {
        $scope.removeSSConfirmationShown = false;
    };

    $scope.removeSurvey = function () {
        if (!$scope.service.survey) return;
        ssWidgetService.removeSurveyInstance($scope.service.survey.link)
            .then(function (r) {
                $timeout(function () {
                    delete $scope.service.survey;
                    $scope.selectedSurveyTemplate = null;
                });
            })
            .catch(function (e) {
                console.error('Something went wrong. Could not delete survey data %o', e);
            });
    }

    $scope.showDisclaimer = function () {
        var currentVehicle = customerModelService.getServiceContract();
        if (currentVehicle && customerModelService._data.currentVehicle.odometer) {
            var odometer = customerModelService._data.currentVehicle.odometer;
            $scope.DisplayEndDate = moment.parseZone(currentVehicle.EndDate, moment.ISO_8601).format('D MMM YYYY');
            //Condition to check if service contract enddate is greater or equal to current date and vehicle odometer reading is less than or equal to service contract odometer reading.
            if (Date.parse(currentVehicle.EndDate) >= Date.parse(new Date()) && (parseInt(odometer) <= parseInt(currentVehicle.EndOdometer))) {
                parseInt(currentVehicle.OilChangesRemaining) > 0 ? $scope.IsContractOilValid = true : false;
                parseInt(currentVehicle.TireRotationRemaining) > 0 ? $scope.IsContractTireRotaionValid = true : false;
                $scope.ProgramName = currentVehicle.ProgramName;
                $scope.ProgramNumber = currentVehicle.ProgramNumber;
                $scope.EndOdometer = currentVehicle.EndOdometer;
                //Condition to check if service mvp service for oil filter change or rotate tires and OilChangesRemaining is greater than zero.
                if ($scope.service.mvpServiceContractOilChange == apiConstants.SERVICECONTRACTS.OilFilterChange && parseInt(currentVehicle.OilChangesRemaining) > 0) {
                    return true;
                }
                else if ($scope.service.mvpServiceContractTireRotation == apiConstants.SERVICECONTRACTS.TireRotaion && parseInt(currentVehicle.TireRotationRemaining) > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    $scope.numberComparison = {
        serviceContractOilChangeValue: apiConstants.SERVICECONTRACTS.OilFilterChange,
        serviceContractTireRotationValue: apiConstants.SERVICECONTRACTS.TireRotaion,
        zeroServicePrice: apiConstants.SERVICEPRICE.Zero
    };

};

// directive controller function injections
ServiceItemController.$inject = ['$scope', '$element', '$attrs', '$state', 'ssWidgetService', '$timeout', 'ApiConstants', 'customerModelService'];
// directive main function
ServiceItemDirective = function () {
    return {
        replace: true,
        restrict: 'E',
        scope: {
            service: '=',
            canAddSurvey: '=?',
            // preselected: '=?',
            // allowDeclinePreselected: '=?',
            displayPrice: '=?',
            showLineComment: '=',
            onBreakPackage: '=?',
            onAddService: '=?',
            serviceContracts: '=?'
        },
        templateUrl: 'template/directives/service-item',
        controller: ServiceItemController
    }
};
// Service Item directive - ui control for manipulating with service
// data according to business logic of the application
//
// @usage
// <data-service-item service="{required service object}"></data-service-item>
//
// service is a required attribute
module.exports = ServiceItemDirective;
